<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact sai krishna

Vue2File :src\Tv_PrimaryOffersites_Client\Velocity.PrimaryOffersites.Web\wwwroot\js\components\rotaionalspecialbanner\LincolnNewRotationalBanners.vue
-->

<template>
  <div
    v-if="paymentdata.length"
    class="vehicle-specials-box vehicle-specials-slider-box g-page-section"
  >
    <div v-if="pathName !== '/'" class="text-center my-4 vehicle-title-wrapper lincoln-new-offers">
      new vehicle offers
    </div>
    <div v-match-heights="setMatchHeightData" style="border-radius: 5px" class="container">
      <VSlickCarousel v-if="paymentdata.length" ref="slick" v-bind="primarySlickOptions">
        <template #prevArrow>
          <em class="arrow-fire primaryicon-right-arrow bgcolor-primary _msbi_background_color slick-arrow"  style="cursor:pointer;z-index:1;color:#212529;right:-17px;"   @click="$refs.slick?.prev()"></em>
        </template>
        <template #nextArrow>
          <em class="arrow-fire primaryicon-left-arrow slick-arrow"  style="color:#cccccc;cursor:pointer;z-index:1;left:-17px;" @click="$refs.slick?.next()"></em>
        </template>
        <div v-for="(paymentoffer, index) in paymentdata" :key="index" class="vehicle-specials">
          <div class="vehicle-specials-banner rounded-box">
            <div class="container">
              <div
                class="row d-flex align-items-center vehicle-specials-bannerwrapper"
                :class="isSubaru ? 'position-relative' : ''"
              >
                <div v-if="isSubaru" class="col-12 incentives mobile-ft-14 py-3 py-md-0">
                  RETAILER INCENTIVE
                </div>

                <div class="col-12 my-3 col-xl wd-250">
                  <div class="d-flex justify-content-center spcecials-vehicle-image">
                    <evox-media-component
                      :styleid="paymentoffer.styleID"
                      :imgurl="
                        paymentoffer.imageHandlerPath +
                        `&edgecrop=true&angle=01&width=330&vehicletype=${paymentoffer.vehicleType}`
                      "
                      :imgstyles="'min-height: 100px; max-height: 200px'"
                      :imgclass="'img-fluid'"
                      :evoxmediastyles="'max-width: 100%'"
                      :alt="`${paymentoffer.modelYear} ${paymentoffer.divisionName} ${paymentoffer.modelName} ${paymentoffer.trim}`"
                      :animation-type="specialRotatorAnimation"
                      :set-match-height="true"
                    />
                  </div>
                </div>
                <div class="col-12 py-3 px-4 col-xl bg-white">
                  <div class="vehicle-specials-vehiclename setHeight2">
                    {{ paymentoffer.offertype }}
                    <span v-if="paymentoffer.offertype">a</span>
                    New {{ paymentoffer.modelYear }} {{ paymentoffer.divisionName }}
                    {{ getModelAndTrimName(paymentoffer) }}
                    {{ insertTradeMark(paymentoffer.styleNameWOTrim) }}
                  </div>

                  <div class="">
                    <div class="price color-linclon f-16 text-left pricing">
                      {{ paymentoffer.offertype }} for
                      {{ formatNumberInString(paymentoffer.offerText1) }}/MO.
                    </div>
                    <div class="vehicle-description f-16 f-16-t-u color-linclon text-left">
                      <div class="terms">
                        {{ formatNumberInString(removePerMonthText(paymentoffer.offerText2)) }}
                        {{ formatNumberInString(paymentoffer.offerText3) }}
                      </div>
                      <template v-if="!hideVINandStock">
                        <div
                          v-if="
                            paymentoffer.vin && paymentoffer.vin.trim() && paymentoffer.vin.length
                          "
                        >
                          VIN:{{ paymentoffer.vin }}
                        </div>
                      </template>
                      <div v-if="paymentoffer.msrp && themeName == 'audi'">
                        MSRP ${{ paymentoffer.msrp | Thousandseperator }}
                      </div>
                      <div
                        v-if="
                          paymentoffer.spcialDisclaimer &&
                          paymentoffer.spcialDisclaimer.trim() &&
                          paymentoffer.spcialDisclaimer.length
                        "
                        class="small-font ft-12 special-disclaimer-mobile"
                      >
                        {{ paymentoffer.spcialDisclaimer }}
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <div class="bt-1">
                      <a
                        class="btn vehicle-specials-viewdetails btn-websites button-link"
                        :href="paymentoffer.vehicleFullName.toLowerCase()"
                        >View Details <span class="primaryicon-circle-right-solid"></span
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VSlickCarousel>
    </div>
  </div>
</template>

<script>
import rotationalSpecialBanners from "./RotationalSpecialsContainer/rotationalspecialbanners";
export default {
  mixins: [rotationalSpecialBanners],
};
</script>

<style lang="less" scoped>
.vehicle-specials-bannerwrapper {
  background: #f5f5f5;
  box-shadow: 0 3px 6px 0 #00000029;
}
._website_gemini .vehicle-specials-bannerwrapper {
  background: #fff !important;
  border: 2px solid #f5f5f5;
  box-shadow: none !important;
}
.vehicle-specials-vehiclename {
  color: #102b4e;
  font-size: 24px;
  line-height: 1.42;
  letter-spacing: 0.72px;
}
.vehicle-specials-viewdetails {
  background: transparent;
  border: 0;
  padding: 6px !important;
  text-align: left;
  color: #102b4e !important;
  font-size: 18px;
  letter-spacing: 0.18px;
}

.vehicle-description::first-letter {
  text-transform: uppercase !important;
}

.vehicle-specials-banner.rounded-box {
  padding: 30px 0;
}
.color-linclon {
  color: #102b4e;
}
.price {
  padding-top: 24px;
  text-transform: uppercase;
}
.f-16-t-u {
  padding: 17px 0 25px;
}
.f-16 {
  font-size: 16px !important;
}
.vehicle-specials-box.vehicle-specials-slider-box.g-page-section .slick-slide {
  margin: 12px;
}
.vehicle-specials-banner {
  height: auto !important;
}
.slick-slide .vehicle-specials {
  background: #ffffff !important;
}

.vehicle-title-wrapper {
  font-size: 35px;
  text-transform: uppercase;
  color: #4d4d4d;
  margin-bottom: 60px !important;
  font-weight: normal;
  padding-top: 1.5rem !important;
  margin-top: 0 !important;
}


@media (max-width: 700px) {
  .vehicle-title-wrapper {
    font-size: 25px;
  }
  .vehicle-specials-box {
    margin-bottom: 42px;
  }
  .f-16-t-u {
    padding: 12px 0px;
  }
  .vehicle-specials-banner.rounded-box {
    padding: 0;
    .container {
      padding: 0;
    }
  }
  .bt-1 {
    padding: 10px 0px;
    border-top: 1px solid #e5e5e5;
    text-align: center;
  }
}
</style>
